/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';
import embedManagementRootReducer from 'state/reducers/embedsState/embedManagementState/root';
import embedAnalytics from 'state/reducers/embedsState/embedAnalytics';
import embedsStatus from 'state/reducers/embedsState/embeds_status';



/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBED MANAGEMENT STATE: ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js
const embedsStateRootReducer = combineReducers({
    embedsStatus,
    embedAnalytics,
    embedManagementState: embedManagementRootReducer
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default embedsStateRootReducer;
